export default __webpack_public_path__ + "static/media/no-image-icon.86aaef97.png";